export default __webpack_public_path__ + "static/media/tata.171c7432.png";